import { NodeType } from "@/app/ivr/bot/utils/enums";

import {
  NumericDialing,
  Option,
  WrongOption,
  VariableCapture,
  SatisfactionRanking,
  ExpiredTime,
  WrongOptionApi,
  OptionConsultApi,
} from "@/app/ivr/bot/utils/nodeBaseBody";

export function nodeFactory(type: NodeType) {
  if (type === NodeType.NumericDialing) return NumericDialing;
  if (type === NodeType.Option) return Option;
  if (type === NodeType.WrongOption) return WrongOption;
  if (type === NodeType.VariableCapture) return VariableCapture;
  if (type === NodeType.SatisfactionRanking) return SatisfactionRanking;
  if (type === NodeType.ExpiredTime) return ExpiredTime;
  if (type === NodeType.WrongOptionApi) return WrongOptionApi;
  if (type === NodeType.OptionConsultApi) return OptionConsultApi;
}
